export default __webpack_public_path__ + "static/media/logo.efb44feb.jpg";